import { inject, Injectable } from '@angular/core';
import { Analytics, logEvent, setUserId } from '@angular/fire/analytics';
import { ChatEvent, LeadEvent, MessageEvent, NotificationEvent, SignInEvent, SignUpEvent, UserSessionEvent } from '@cfg-interface/analytics.interface';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(
              private analytics: Analytics
              ) { }

  logUserEvent(eventParams: UserSessionEvent): void {
    logEvent(this.analytics, 'user_session', eventParams)
  }

  logCustomEvent(event_name: string, args: any): void {
    logEvent(this.analytics, event_name, args);
  }

  logSignUpEvent(eventParams: SignUpEvent): void {
    setUserId(this.analytics, `${eventParams?.uid}`);
    delete eventParams.uid;
    logEvent(this.analytics, 'sign_up', eventParams);
  }

  logSignInEvent(eventParams: SignInEvent): void {
    setUserId(this.analytics, `${eventParams?.uid}`);
    delete eventParams.uid;
    logEvent(this.analytics, 'sign_in', eventParams);
  }

  logNewLead(eventParams: LeadEvent): void {
    logEvent(this.analytics, 'generate_lead', eventParams);
  }

  logSelectedChat(eventParams: ChatEvent): void {
    logEvent(this.analytics, 'select_chat', eventParams);
  }

  logSentMessageChat(eventParams: MessageEvent): void {
    logEvent(this.analytics, 'sent_message', eventParams)
  }

  logSentChatNotification(eventParams: NotificationEvent): void {
    logEvent(this.analytics, 'sent_notification', eventParams);
  }

  // Push Notification tracking is in Back-End Side

}
